module.exports = __webpack_public_path__ + "static/32b594ef1b6144bd1296dd6158724bc4c6abff86f85430a570c39b0b9a2df29d-f8f79e3423abe7aece1c43342a1fcaff.jpeg";